var map = {
	"./bianca.png": "W7Tv",
	"./favicons/android-chrome-144x144.png": "YzIW",
	"./favicons/android-chrome-192x192.png": "kUMe",
	"./favicons/android-chrome-36x36.png": "AtE7",
	"./favicons/android-chrome-48x48.png": "uP+R",
	"./favicons/android-chrome-72x72.png": "zaw9",
	"./favicons/android-chrome-96x96.png": "SYcy",
	"./favicons/apple-touch-icon-114x114.png": "Co1c",
	"./favicons/apple-touch-icon-120x120.png": "3iYd",
	"./favicons/apple-touch-icon-144x144.png": "4Nke",
	"./favicons/apple-touch-icon-152x152.png": "iDg0",
	"./favicons/apple-touch-icon-180x180.png": "6wkO",
	"./favicons/apple-touch-icon-57x57.png": "Fc5q",
	"./favicons/apple-touch-icon-60x60.png": "tA53",
	"./favicons/apple-touch-icon-72x72.png": "vzX6",
	"./favicons/apple-touch-icon-76x76.png": "O+KM",
	"./favicons/apple-touch-icon-precomposed.png": "9FX0",
	"./favicons/apple-touch-icon.png": "sE3q",
	"./favicons/browserconfig.xml": "NwOb",
	"./favicons/favicon-16x16.png": "DoIq",
	"./favicons/favicon-32x32.png": "eo5f",
	"./favicons/favicon-96x96.png": "Qjph",
	"./favicons/favicon.ico": "8ie2",
	"./favicons/manifest": "Nu8M",
	"./favicons/manifest.json": "Nu8M",
	"./favicons/mstile-144x144.png": "DxXn",
	"./favicons/mstile-150x150.png": "WpiF",
	"./favicons/mstile-310x150.png": "1+Ow",
	"./favicons/mstile-310x310.png": "zGsQ",
	"./favicons/mstile-70x70.png": "Pq9h",
	"./favicons/safari-pinned-tab.svg": "4dGR",
	"./heart.gif": "oVCE",
	"./plus.svg": "zU9F",
	"./simon.png": "+2ra",
	"./teaser_streckennetz.jpg": "wrLf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1